export default __webpack_public_path__ + "static/media/landscape30.73542973.JPG";